// import axios from "axios";
import { MessageBox, Message } from "element-ui";
import QuickAxios from "quick-axios";

const quickAxiosConfig = {
  // 发生错误时，是否显示提示
  tip: true, // default

  // 如何显示提示，可以传入显示message的方法
  tipFn: (message) => { },
  errorHandlers: {
    // 支持 400/401/403/404/405/413/414/500/502/504/任意其他 errno
    400: () => {
      const url = encodeURIComponent(window.location.href);
      const loginUrl = process.env.VUE_APP_LOGIN_API + '/account/login?from=' + url;
      window.location.href = loginUrl;
    },
    401: () => {
      // 学院的接口使用的正式环境，与测试环境登陆判断冲突，所以仅在线上环境打开401时跳转登陆
      if(process.env.VUE_APP_ENV==='prod'){
        const url = encodeURIComponent(window.location.href);
        const loginUrl =
          process.env.VUE_APP_LOGIN_API + '/account/login?from=' + url;
        window.location.href = loginUrl;
      }
    },
    403: () => {
      Message({
        message: "您目前没有权限进行当前操作",
        type: "error",
        duration: 3 * 1000,
      });
    },
    // ...
  },
  // validateStatus: status => {
  //   return status === 0 || (status >= 200 && status < 300);
  // },
  // const defaultValidateStatus = (status) => status === 0 || (status >= 200 && status < 300);
  // this.validateStatus = isFunction(validateStatus) ? validateStatus : defaultValidateStatus;
  // 内置错误提示语言: 'zh-cn'/'en'
  lang: "zh-cn", // default
  // 请求前的自定义操作
  beforeHook: function (config) {
    // this._apiPath = config.url;
    // // 退出登录后，token 重置为undefuned， 重新 登录后 需要重新挂载token 到请求头
    // if (config.headers && !config.headers.Authorization) {
    //     config.headers.Authorization = (store && store.getters.token) || "";
    // }
  },
  //    // 请求后的自定义操作
  //   afterHook: (response|error, isError) => {},
  // 请求后的自定义操作
  afterHook: (response, error) => {
    if (error) return Promise.reject(new Error("Error"));
    const res = response.data;
    const code = res.code;

    if (code == 400) {
      const url = encodeURIComponent(window.location.href);
      const loginUrl = process.env.VUE_APP_LOGIN_API + '/account/login?from=' + url;
      window.location.href = loginUrl;
      return res;
    } else if (code !== 200 && code > 200) {
      Message({
        message: res.message || "接口异常",
        type: "error",
        duration: 3 * 1000,
      });
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (code === 50008 || code === 50012 || code === 50014) {
        // to re-login
        MessageBox.confirm(
          "您已注销，可以取消以停留在此页面，或重新登录",
          "确认退出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => { });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  // 从请求响应中获取错误状态，默认取errno
  // 如果传入的不是一个函数也会使用默认值
  // default  resData.errorno
  getResStatus: (resData) => {
    return resData.code;
  },
  // 从请求响应中获取错误消息，默认取errmsg
  // 如果传入的不是一个函数也会使用默认值
  getResErrMsg: (resData) => resData.message, // default
  // 从请求响应中获取返回数据，默认取data
  // 如果传入的不是一个函数也会使用默认值
  getResData: function (resData) {
    resData.status = resData.code;
    // 1.开发环境 可以自定义数据
    // if (process.env.NODE_ENV === 'development') {
    //   const devResData = require('./devResData/index').default
    //   const newResData = devResData(resData, this._apiPath)
    //   return newResData
    // }
    return resData; // default
  },
  // 是否开启取消重复请求
  cancelDuplicated: true, // default false
  // 如果开启了取消重复请求，如何生成重复标识
  duplicatedKeyFn: (config) => {
    // return `${config.method}${config.url}` // default
    return `${config.method}${config.url}${JSON.stringify(config.params)}`; // default
  },
};
const axiosConfig = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  withCredentials: true,
  headers: {},
};
// 此处 quickAxiosConfig, axiosConfig 未定义，下面会详细介绍 quickAxiosConfig
const request = new QuickAxios(quickAxiosConfig, axiosConfig);
export default request;
// 该编码的特殊请求 实例子 application/x-www-form-urlencoded
export const RequestByFormUrlEncode =  new QuickAxios({...quickAxiosConfig,
  beforeHook: function (config) {
   config.headers['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
   return config
}}, {...axiosConfig});

